import React from 'react'
import { CheckIcon } from '@phosphor-icons/react'

interface FormCheckboxProps {
  id: string
  checked: boolean
  onChange: (checked: boolean) => void
  label: string
  small?: boolean
}

export const FormCheckbox = ({
  id,
  checked,
  onChange,
  label,
  small,
}: FormCheckboxProps) => (
  <label className="employee-form__checkbox" htmlFor={id}>
    <input
      className="employee-form__checkbox-input"
      type="checkbox"
      id={id}
      checked={checked}
      onChange={e => onChange(e.target.checked)}
    />
    <span
      className={`employee-form__checkbox-box ${
        checked ? 'employee-form__checkbox-box--checked' : ''
      } ${small ? 'employee-form__checkbox-box--sm' : ''}`}
      aria-hidden="true"
    >
      {checked && <CheckIcon size={small ? 10 : 12} weight="bold" />}
    </span>
    <span className="employee-form__checkbox-label">{label}</span>
  </label>
)
